import {
  createStaticResult,
  getInfoBaseCategories,
  getInfoBaseDetail,
  getInfoBaseList,
} from "@/data/siteContent";

export function artInfoBaseList(params) {
  return getInfoBaseList(params);
}

export function artInfoBaseDetail(id) {
  return createStaticResult(getInfoBaseDetail(id));
}

export function artDictCategory() {
  return createStaticResult(getInfoBaseCategories());
}
